import React, { useState, useEffect } from 'react'
import cx from 'classnames'
import { useInterval } from '@hooks'
import moment from 'moment'

import { Icon, Counter, Text, Link } from './'

const UserElement = (props) => {
  const { timezone: { value: timezone } = {}, subtext } = props
  const [time, setTime] = useState(
    timezone ? moment.tz(moment(), timezone).format('h:mm A') : null
  )

  useEffect(() => {
    setTime(timezone ? moment.tz(moment(), timezone).format('h:mm A') : null)
  }, [timezone])

  useInterval(
    () => {
      setTime(moment.tz(moment(), timezone).format('h:mm A'))
    },
    timezone ? 60 * 1000 : null
  )

  return (
    <section
      className={`ui gp-user ${props.className} ${
        props.reversed ? 'reversed' : ''
      } ${props.name && !props.hideName ? 'with-name' : ''} ${props.size}`}
      style={props.style}
      {...props.events}
    >
      <div
        className={`avatar-container ${
          props.img || (!props.img && !props.name)
            ? 'with-img'
            : 'with-initials'
        }`}
      >
        {props.img || (!props.img && !props.name) ? (
          <img
            src={props.img}
            {...props.imgProps}
            onError={(e) =>
              (e.target.src =
                'https://endeis.s3.us-west-2.amazonaws.com/no_avatar@2x.png')
            }
          />
        ) : (
          <div
            className={cx(
              'initials-container',
              props.img || (!props.img && !props.name)
                ? ''
                : `initials-container--${props.type || 'default'}`
            )}
          >
            <Text>
              {props.name.includes('undefined')
                ? ''
                : `${props.name.charAt(0).toUpperCase()}${props.name
                    .charAt(1)
                    .toLowerCase()}`}
            </Text>
          </div>
        )}
        {props.online && !props.counter && <span className='online' />}
        {props.counter && <Counter value={props.counter} />}
        {props.notification && <span className='notification' />}
        {props.volunteer && <div className='volunteer'>V</div>}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {props.name && !props.hideName && (
          <Text className='name semibold'>
            {props.hideLastname ? props.name.split(' ')[0] : props.name}
          </Text>
        )}
        {props.info && props.info()}
        {!!time && (
          <div className='localTime'>
            <Icon name='time outline' style={{ fontSize: '12px' }} />
            <Text
              className='text-c'
              style={{ lineHeight: 1, marginLeft: 4, marginTop: 1 }}
            >
              <span className='caption'>It&apos;s&nbsp;</span>
              <span className='semibold'>{time}</span>
              <span className='caption'>{` for ${
                props.name.split(' ')[0]
              }`}</span>
            </Text>
          </div>
        )}
        {!!subtext && (
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              marginTop: 4
            }}
          >
            <Text
              className={`text-c ${props.subtextClassName}`}
              style={{ lineHeight: 1, marginTop: 1 }}
            >
              {subtext}
            </Text>
          </div>
        )}
      </div>
      {props.icon && <Icon name={props.icon} {...props.iconProps} />}
    </section>
  )
}

const User = (props) =>
  props.isLink && props.id !== undefined ? (
    <Link href={`/profile/${props.id}`} noDecoration {...props.linkContainer}>
      <UserElement {...props} />
    </Link>
  ) : (
    <UserElement {...props} />
  )

User.defaultProps = {
  className: '',
  style: {},
  imgProps: {},
  size: 'medium',
  img: '',
  hideName: false,
  events: {}
}

export default User
